export function gtag(...args) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  try {
    window.gtag(...args);
  } catch {
    // ignore
  }
}

export function trackAdsConversion(sendTo) {
  if (!sendTo) return;
  gtag('event', 'conversion', { send_to: sendTo });
}


